import { SectionNotes } from 'services/api/vehicle-sections/types';

export const useAiDescription = (notes?: SectionNotes, imageType?: string) => {
  // const isVisible = !!notes?.ai_description || (!!notes?.ai_message && imageType?.endsWith('_tire'));
  const isVisible = !!notes?.ai_description;
  const value = (() => {
    if (!isVisible) return '';
    return notes.ai_description!;
    // return imageType?.endsWith('_tire') ? notes.ai_message! : notes.ai_description!;
  })();

  return { isVisible, value };
};
